import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MentionTextArea } from '@como/web-hub-components';
import * as smsUtils from './sendSMS.view.utils';
import { getEmailMentionsWithDisplay } from './mentions';
import './SMSAreaWithMensions.styles.less';

const SMSAreaWithMentions = ({ message, unsubscribeMessage, providerName, error, onChange, postScriptum, title, formatMessage, disabled }) => {

  const [messageLength, setMessageLength] = useState(smsUtils.getMessageContentLength(message, unsubscribeMessage));
  const [messagesCount, setMessagesCount] = useState(smsUtils.getMessagesCount(message, unsubscribeMessage, providerName));

  const getMentionsList = () => getEmailMentionsWithDisplay(formatMessage);

  const onTextUpdate = (newMessage) => {
    const messageContentLength = smsUtils.getMessageContentLength(newMessage, unsubscribeMessage);
    const numberOfMessages = smsUtils.getMessagesCount(newMessage, unsubscribeMessage, providerName);

    setMessageLength(messageContentLength);
    setMessagesCount(numberOfMessages);
  };

  return (
    <div className={`sms-area-with-mentions ${disabled ? 'disabled' : ''}`}>
      {title && <div className="sms-area-with-mentions-title">{title}</div>}
      <div className="sms-area-with-mentions-content">
        <MentionTextArea
          disabled={disabled}
          hideTips
          mentionOptions={getMentionsList()}
          message={message}
          onTextUpdate={(newMessage) => {
            onTextUpdate(newMessage);
            onChange(newMessage);
          }
          }
          error={error}
          singleLine
        />
        <div className="sms-area-with-mentions-content-info">
          <span className="text-length counter">
            {formatMessage({id: unsubscribeMessage !== null && unsubscribeMessage.length > 0 ? 'sms.mentions.message.length' : 'sms.mentions.message.length.without.unsubscribe.text'}, {messageLength})}
          </span>
          <span className="charged-messages counter">
            {formatMessage({id: 'sms.mentions.messages.count'}, {messagesCount})}
          </span>
        </div>
      </div>
      {postScriptum &&
      <div className="sms-area-with-mentions-ps">
        <span>
          {postScriptum}
        </span>
      </div>
      }

    </div>
  );
};

SMSAreaWithMentions.propTypes = {
  message: PropTypes.string.isRequired,
  formatMessage: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  unsubscribeMessage: PropTypes.string,
  providerName: PropTypes.string,
  error: PropTypes.string,
  postScriptum: PropTypes.string,
  disabled: PropTypes.bool
};

export default SMSAreaWithMentions;
